<template>
  <!-- 季度产量 -->
  <div class="production">

    <table class="mytable" style="width: 50%">
      <thead>
        <tr>
          <th>产品名称</th>
          <th>季度产量指标</th>
          <th>季度实际产量</th>
          <th>
            <i @click="add" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
          </th>
        </tr>
      </thead>
      <tbody>

        <tr v-for="(item,i) in tableData" :key='i'>
          <td>
            <el-input v-model="item.proName" maxlength="20" show-word-limit placeholder="产品名称"></el-input>
          </td>
          <td>
            <el-input v-model="item.proData" type="number" oninput="if(value.length > 8) value=value.slice(0, 8)" placeholder="请输入"></el-input>
          </td>
          <td>
            <el-input v-model="item.proTarget" type="number" oninput="if(value.length > 8) value=value.slice(0, 8)" placeholder="请输入"></el-input>
          </td>
          <td style="width: 6rem;text-align: center;">
            <i @click="del(item, i) " class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>
          </td>
        </tr>

      </tbody>
    </table>
    <p v-if="!tableData.length" style="width: 50%;text-align: center;margin-top: 5rem;">暂无数据</p>

    <div style="margin-top: 2rem">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>

  </div>
</template>

<script>
import api from '@/apis/produce/production'
export default {
  components: {},
  data() {
    return {
      tableData: [],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            
            this.tableData = res.data.list
            
          } else {
            this.$message.error(res.message)
          }
        })
    },
    add() {
      this.tableData.push({
        proName: '',
        proData: '', //季度实际产量
        proTarget: '', //季度产量指标
      })
    },
    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.production { padding-top:10px;
}
</style>